// extracted by mini-css-extract-plugin
export default {"BtnArrow":"Swiper_BtnArrow__ZhA-x","BtnArrowRight":"Swiper_BtnArrowRight__gLZhB","BtnArrowLeft":"Swiper_BtnArrowLeft__Kh-Ly"};